import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserType } from '../core/authentication';
import { State } from './reducers/authentication.reducer';

export const selectAuthenticationState = createFeatureSelector<State>('appAuthentication');
export const selectSessionState = createSelector(
    selectAuthenticationState,
    state => state.session
);
export const selectIsFliptoStaff = createSelector(
    selectSessionState,
    session => session.UserType === UserType.Admin
);
